import { Fn_activeAxios } from "function/FnConfig";

export type AgencyListReq = {
  rootStore: any;
  shopCd: string;
  token: string;
}

export type AgencyListRes = {
  mobileOrderFg: string;
  channelName: string;
  channelFieldName: string;
  mapping: boolean;
  isMapping: boolean;
}

export type AgencyListResponse<T> = {
  resultCode: string;
  resultMsg: string;
  data: T;
}

// 주문 제휴사 조회
export const getAgencyList = async (payload: AgencyListReq): Promise<AgencyListResponse<AgencyListRes[]>> => {
  const api = Fn_activeAxios(payload.rootStore);
  const response = await api.get(`/gate/okgo/agency/${payload.shopCd}`, {
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + payload.token },
  });

  return response.data;
};
